document.addEventListener("DOMContentLoaded", function() {
  const link = document.getElementById("HeaderMenu-national-chapter");
  if (link) {
    link.addEventListener("click", function(e) {
      e.preventDefault();
      const modal = document.getElementById("exitModal");
      modal.style.display = "block";

      const targetUrl = link.href;

      // Wait seconds, then open link
      setTimeout(() => {
        window.location.href = targetUrl;
      }, 2000);
    });
  }
});